/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('public.note', ['data.note', 'popup.note']);
